import React from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import Svg, { Circle, Path } from 'react-native-svg';

interface IconProps {
	style?: StyleProp<ViewStyle & { tintColor?: string; fillColor?: string }>;
	width?: number;
	height?: number;
	strokeWidth?: number;
}

export const InfoIconCustom: React.FC<IconProps> = ({
	style,
	width = 24,
	height = 24,
	strokeWidth = 1.5,
}) => {
	const styles = StyleSheet.flatten(style);

	return (
		<Svg width={width} height={height} viewBox="0 0 24 24" fill={styles?.fillColor || 'none'}>
			<Circle
				cx="12"
				cy="12"
				r="10"
				stroke={styles?.tintColor}
				strokeWidth={strokeWidth}
				fill={styles?.fillColor || 'none'}
			/>
			<Path
				d="M12 16V12"
				stroke={styles?.tintColor}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
			/>
			<Path
				d="M12 8H12.01"
				stroke={styles?.tintColor}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
			/>
		</Svg>
	);
};
